import { Brand } from "@championcare/ui";
import { Link, useRouter } from "../router";
import { patientSignInUrl } from "../config";

/** Marketing footer mirroring `.footer` in championcare-design. */
export function Footer() {
  const { path, navigate } = useRouter();
  const scrollTo = (id: string) => {
    const go = () => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    if (path !== "/") {
      navigate("/");
      setTimeout(go, 60);
    } else {
      go();
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="brand" aria-label="Champion Care home">
              <Brand size={22} />
            </Link>
            <p className="footer-tag">Care that <em>champions</em> you.</p>
            <p className="footer-desc">
              Premium telehealth from board-certified physicians, available on demand in all 50
              states.
            </p>
          </div>

          <div className="footer-col">
            <h5>Get care</h5>
            <ul>
              <li><button onClick={() => navigate("/signup")}>Book a visit</button></li>
              <li><button onClick={() => scrollTo("how")}>How it works</button></li>
              <li><button onClick={() => scrollTo("plans")}>View plans</button></li>
              <li><button onClick={() => navigate("/signup")}>AI Concierge</button></li>
            </ul>
          </div>

          <div className="footer-col">
            <h5>Account</h5>
            <ul>
              <li><button onClick={() => navigate("/signup")}>Create account</button></li>
              <li><a href={patientSignInUrl()}>Sign in</a></li>
              <li><a href={patientSignInUrl()}>Reset password</a></li>
              <li><button onClick={() => scrollTo("faq")}>FAQ</button></li>
            </ul>
          </div>

          <div className="footer-col">
            <h5>Company</h5>
            <ul>
              <li><button onClick={() => navigate("/")}>About</button></li>
              <li><button onClick={() => navigate("/")}>Careers</button></li>
              <li><button onClick={() => navigate("/")}>Press</button></li>
              <li><button onClick={() => navigate("/signup")}>Contact</button></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-disclaimer">
            <strong>Important:</strong> ChampionCare is a telehealth platform that connects you with
            independent, board-certified physicians. It does not replace emergency care — if you're
            experiencing a medical emergency, call <strong>911</strong> or go to your nearest
            emergency room. Treatment availability varies by state and clinical appropriateness.
            <br /><br />
            © 2026 ChampionCare, Inc. · All rights reserved · <button className="footer-legal-link" onClick={() => navigate("/")}>Privacy</button> · <button className="footer-legal-link" onClick={() => navigate("/")}>Terms</button> · <button className="footer-legal-link" onClick={() => navigate("/")}>Accessibility</button>
          </div>
          <div className="footer-social">
            <a aria-label="X (formerly Twitter)"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg></a>
            <a aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></svg></a>
            <a aria-label="LinkedIn"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.063 2.063 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452z" /></svg></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
